<app-loadable-content [loadingController]="eventsLoadingController" (onRetry)="loadInitialData()">
    <mat-card>
        <mat-card-header>
            <mat-card-title>{{ 'events' | translate }}</mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <table width="100%">
                <tr>
                    <td>
                        <app-data-table
                            [data]="events"
                            [columns]="columns"
                            [toolbarActions]="eventToolbarModel.actions"
                            [compactToolbarActions]="eventToolbarModel.compactActions">
                        </app-data-table>
                    </td>
                </tr>
                <tr>
                    <td align="right">
                        <app-indeterminate-paginator [model]="paginatorModel" [pageSize]="10" [initialData]="initialPaginatorData"></app-indeterminate-paginator>
                    </td>
                </tr>
            </table>
        </mat-card-content>
    </mat-card>
</app-loadable-content>
